import { connect } from "react-redux";
import _ from "lodash";

import { fetchEngagementAssetViewsGraphReport } from "src/legacy/redux/actions/reports.jsx";
import withUseHooks from "src/legacy/components/withUseHooks";

import AssetView from "./view";

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.legacyRootReducer.reports.engagement.assetViewsGraph.loading,
    data: state.legacyRootReducer.reports.engagement.assetViewsGraph.item,
    count: _.sumBy(state.legacyRootReducer.reports.engagement.assetViewsGraph.item, (item) => item.value )
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEngagementAssetViewsGraphReport: (filter) => {
      return dispatch(fetchEngagementAssetViewsGraphReport(filter));
    },
  };
};

const AssetViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetView);

export default withUseHooks(AssetViewContainer);